import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, LineClamp } from '../../../../../global/commonStyle';

const Header = styled.div`
  ${FlexBetween}
  padding: var(--space-0);
  width: 100%;
  gap: var(--space-10);
`;

const LeftHeader = styled.div`
  ${AlignCenter}
  padding: var(--space-0);
  gap: var(--space-10);

  .header-icon {
    fill: var(--background-primary);
    stroke: var(--text-secondary);
    path {
      stroke: none;
    }
  }
`;

const RightHeader = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  position: relative;

  .dot-icon {
    cursor: pointer;
    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }

    path {
      fill: var(--text-primary);
    }
  }
`;

const Title = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);

  ${mobile_xl(css`
    ${LineClamp(2)}
  `)}
`;

const Plus = styled.div`
  position: absolute;
  top: 4px;

  ${mobile_xl(css`
    top: 4px;
  `)}
`;

const IconHide = styled.div`
  padding: var(--space-3);
  ${FlexCenter}
  position: absolute;
  left: -23px;
  top: 12px;
  cursor: pointer;

  .dotted-icon {
    opacity: 0;
    fill: var(--text-secondary);
  }

  ${mobile_xl(css`
    left: 0;
    top: 15px;
    ${FlexCenter}

    .dotted-icon {
      opacity: 0;
      visibility: hidden;
    }
  `)}
`;

const DropDiv = styled.div`
  display: inline-flex;

  .active-state {
    display: inline-flex;
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;

const DragHandle = styled(IconHide)<{ isSortable?: boolean }>`
  cursor: ${(props) => (props.isSortable ? 'grab' : 'default')};

  &:active {
    cursor: ${(props) => (props.isSortable ? 'grabbing' : 'default')};
  }
`;

export { Header, LeftHeader, RightHeader, Title, Plus, IconHide, DropDiv, DragHandle };
